import { Controller } from "@hotwired/stimulus"

// Polls the PO analysis status as lightweight JSON so the "Reading your
// purchase order…" interstitial stays perfectly still — the old full-page
// <meta http-equiv="refresh"> reloaded the whole layout every 2s, which made
// the card visibly flash and shift. The moment the job is no longer
// processing, navigate once to the same path (HTML), which renders the review
// screen or bounces back with an alert.
export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 2000 }
  }

  connect() {
    this.stopped = false
    this.tick = this.tick.bind(this)
    this.timer = setInterval(this.tick, this.intervalValue)
  }

  disconnect() {
    this.stopped = true
    clearInterval(this.timer)
  }

  async tick() {
    let state
    try {
      const res = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
        credentials: "same-origin"
      })
      if (!res.ok) return // transient (auth blip, 5xx) — try again next tick
      state = (await res.json()).state
    } catch (_e) {
      return // network blip — keep polling rather than bailing out
    }
    if (this.stopped) return
    if (state && state !== "processing") {
      clearInterval(this.timer)
      this.stopped = true
      window.location.href = this.urlValue
    }
  }
}
